const React = require("react");

function PresentationChartBarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
  }));
}

module.exports = PresentationChartBarIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/PresentationChartBarIcon.js
 ** module id = 588
 ** module chunks = 0
 **/